import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-24 bg-background-950 text-background-200">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block text-xs font-medium tracking-widest uppercase text-accent-400 bg-accent-500/20 px-3 py-1 rounded-full mb-4">
              移动端入口
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-black text-white mb-4">
              {appData.title}
            </h2>
            <p className="text-lg md:text-xl text-accent-300 font-medium mb-4">
              {appData.subtitle}
            </p>
            <p className="text-sm md:text-base text-background-400 leading-relaxed max-w-lg mb-8">
              {appData.description}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
              {appData.features.map((f, i) => (
                <div key={i} className="flex items-center gap-2">
                  <div className="w-6 h-6 rounded-full bg-primary-500/20 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-primary-400 text-sm"></i>
                  </div>
                  <span className="text-sm text-background-300">{f}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3">
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto text-center bg-primary-500 text-white font-bold px-8 py-3 rounded-md text-base hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-wechat-line mr-2"></i>微信扫码体验
              </a>
              <span className="text-xs text-background-500">微信搜索"每日吃瓜"即可直达</span>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="w-64 md:w-72 rounded-lg overflow-hidden border-2 border-background-800">
              <img
                src={appData.image}
                alt="每日吃瓜小程序"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}